export default function initServicesModal() {
   const serviceBtns = document.querySelectorAll('.js-service-btn');
   const closeBtns = document.querySelectorAll('.js-service-close');
   const modals = document.querySelectorAll('.js-service-modal');

   // Abre el modal especifico
   serviceBtns.forEach(btn => {
      btn.addEventListener('click', () => {
         const modalId = btn.getAttribute('data-modal');
         const targetModal = document.getElementById(modalId);
         if (targetModal) {
            targetModal.classList.add('active');
         }
      });
   });

   // Cierra el modal (boton x)
   closeBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
         e.target.closest('.js-service-modal').classList.remove('active');
      });
   });

   // Cierra al clicar afuerita del recuadro
   modals.forEach(modal => {
      modal.addEventListener('click', (e) => {
         if (e.target === modal) {
            modal.classList.remove('active');
         }
      });
   });

   // Cierra con escape key
   document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
         modals.forEach(modal => {
            if (modal.classList.contains('active')) {
               modal.classList.remove('active');
            }
         });
      }
   });
}
